/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import { Header } from "../../Header";
import FacilitiesIcon from "../../../../assets/FacilitiesIcon";
import axios from "axios";
import { BaseUrl } from "../../../redux/config";
import { getSession } from "../../../redux/actions/authActions";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import CustomTable from "../../../../components/Table";
import styles from "./dashboard.module.css";
import { toast } from "react-toastify";
import {
  UpdateCardData,
  generateStatusByDateChartOption,
  getFilteredOrders,
} from "./constant";
import * as echarts from "echarts/core";
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
} from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import TotalOrdersByDate from "./TotalOrdersByDate";
import PayoutByDate from "./PayoutByDate";
import SalesByDate from "./SalesByDate";
import Card from "./Cards";
import commObj from "../../../constants/Common";
import StatusByDateChart from "./StatusByDateChart";
import { cardData as initialCards } from "./constant";
dayjs.extend(isBetween);

const MainDashboard = () => {
  const { token, role_id, user_profile_id } = getSession();
  const [orders, setOrders] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState("all");
  const [totalUsersData, setTotalUsersData] = useState("all");
  // for filter Orders on basis of week/month/Years
  const [filterOrders, setFilterOrders] = useState([]);
  const filterParams = ["all", "week", "month", "year"];
  const [cardData, setCardData] = useState([...initialCards]);

  echarts.use([
    TooltipComponent,
    GridComponent,
    LegendComponent,
    MarkLineComponent,
    BarChart,
    CanvasRenderer,
  ]);

  // update Card Data

  const columns = useMemo(
    () => [
      {
        header: "Order Id",
        accessorKey: "order_id",
      },
      {
        header: "Order By",
        accessorKey: "order_by",
      },
      {
        header: "Service Name",
        accessorKey: "svc_name",
      },
      {
        header: "Facility Name",
        accessorKey: "svcf_name",
      },
      {
        header: "Service Price",
        accessorKey: "svc_price_amt",
      },
      {
        header: "Order Date",
        accessorKey: "ord_svc_date",
      },
    ],
    []
  );

  function sleep(delay = 1000) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, delay);
    });
  }

  const fetchUserOrder = async () => {
    try {
      await sleep(1000);
      const { data, status } = await axios.get(`${BaseUrl}serviceOrd`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          user_profile_id,
          role_id,
          startDate: "2024-06-01",
          endDate: commObj.getCurrentDate(),
          status_id: "all",
        },
      });
      if (data && status === 200) {
        setOrders(data?.usr?.rec);
        setFilterOrders(data?.usr?.rec);
        setTotalUsersData(data?.usr?.recU[0]);
      }
    } catch (error) {
      toast.error(error.response?.data?.usr?.message);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUserOrder();
    }
  }, [token]);

  useEffect(() => {
    const filteredOrderResponse = getFilteredOrders(selectedDuration, orders);
    setFilterOrders(filteredOrderResponse);
    UpdateCardData(
      filteredOrderResponse,
      setCardData,
      selectedDuration,
      totalUsersData
    );
    // on change in either week/month/year or orders => update filterOrders
  }, [selectedDuration, orders]);

  // *****************************  Order by Date and Status  Start*****************************
  const orderStatusByDate = filterOrders?.reduce((acc, order) => {
    const date = order.ord_svc_date;
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(order);
    return acc;
  }, {});

  const orderStatusChartByDate = Object.keys(orderStatusByDate)?.map((date) => {
    const orders = orderStatusByDate[date];

    const count = orders?.reduce((acc, order) => {
      const statusCode = order?.order_status_id;
      acc[statusCode] = (acc[statusCode] || 0) + 1;
      return acc;
    }, {});
    return {
      date,
      ...count,
    };
  });

  const statusByDateChartOption = generateStatusByDateChartOption(
    orderStatusChartByDate
  );
  // *****************************  Order by Date and Status  End *****************************

  //******************************* Total Order By Date Start ******************************** */
  const totalOrdersByDate = filterOrders?.reduce((acc, order) => {
    const date = order.ord_svc_date;
    if (acc[date]) {
      acc[date] += 1;
    } else {
      acc[date] = 1;
    }
    return acc;
  }, {});

  const totalOrdersChartDataDate = Object.keys(totalOrdersByDate);
  const totalOrdersChartDataValue = Object.values(totalOrdersByDate);
  //******************************* Total Order By Date End ******************************** */

  //******************************* Total Payout By Date Start ******************************** */

  const dateCountsByPayout = filterOrders?.reduce((acc, data) => {
    const amount = data?.svc_provider_cost_amt;
    const date = data?.ord_svc_date_orig;
    if (acc[date]) {
      acc[date] += Number(amount);
    } else {
      acc[date] = Number(amount);
    }
    return acc;
  }, {});

  const PayoutChartDataDate = Object.keys(dateCountsByPayout);
  const PayoutChartDataValue = Object.values(dateCountsByPayout);

  //******************************* Total Payout By Date End ******************************** */

  //******************************* Total Sells By Date Start ******************************** */

  const sellCostChartData = Object.keys(orderStatusByDate)?.map((date) => {
    const orders = orderStatusByDate[date];
    const totalSales = orders?.reduce(
      (acc, order) => acc + Number(order?.order_tot_amt),
      0
    );
    return {
      date,
      sell: totalSales,
    };
  });
  const sellCostChartDataDate = sellCostChartData?.map((item) => item?.date);
  const sellCostChartDataValue = sellCostChartData?.map((item) => item?.sell);
  //******************************* Total Sells By Date Start ******************************** */

  return (
    <div className={styles.MainDashboardWrapper}>
      <Header pageTitle="Main Dashboard" icon={<FacilitiesIcon />} />
      <div
        className={styles.dashboardHeaderWrapper}
        // className="px-[0.75rem] sm:px-8 mt-4  mb-3  flex items-center justify-between"
      >
        <div className="text-base max-sm:text-[26px] text-[26px] sm:text-[26px]  w-full whitespace-nowrap">
          Dashboard
        </div>
        <div className={styles.headerRightWrapper}>
          <div className="filters flex justify-end border">
            {filterParams?.map((item, index) => (
              <div
                key={item}
                className={
                  `cursor-pointer capitalize px-[5px] py-[10px] md:px-[10px] md:py-[20px] flex justify-center items-center h-[30px] w-fit ${
                    selectedDuration === item
                      ? `bg-blue-600 text-white`
                      : "bg-white text-gray-700"
                  } ${index > 0 ? "border-l border-gray-300" : ""}`
                  // ${index == 0 || index === filterParams.length - 1 && "rounded-lg"}`
                }
                onClick={() => setSelectedDuration(item)}
              >
                <h3 className="text-sm font-medium px-[10px] py-[5px] m-0">
                  {item}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="px-10 grid grid-cols-3 sm:grid-cols-6 xl:grid-cols-12 sm:gap-x-2 gap-y-4">
        {cardData?.map((item, idx) => {
          return (
            <div className="col-span-3 sm:col-span-3 md:col-span-3" key={idx}>
              <Card item={item} />
            </div>
          );
        })}
      </div>

      <div className="p-[40px]">
        <div className={styles.dashboardBodyWrapper}>
          <div className={styles.dashboardBodyWrapperLeft}>
            <StatusByDateChart chartOption={statusByDateChartOption} />
            <div className="my-[20px]">
              <CustomTable
                columns={columns}
                data={filterOrders}
                hidePagination
              />
            </div>
          </div>
          <div className={styles.dashboardBodyWrapperRight}>
            {/* Total Orders By Date  */}
            <TotalOrdersByDate
              totalOrdersChartByDate={totalOrdersChartDataDate}
              totalOrdersChartByValue={totalOrdersChartDataValue}
            />

            {/* Total Payout By Date  */}
            <PayoutByDate
              dates={PayoutChartDataDate}
              values={PayoutChartDataValue}
            />
            {/* Total Sales By Date  */}
            <SalesByDate
              dates={sellCostChartDataDate}
              values={sellCostChartDataValue}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainDashboard;
